import axios from 'axios';

import { getTokenTMOV, startRefreshToken } from '../security/authService';

const apiAuth = axios.create({
  baseURL: process.env.REACT_APP_API_AUTH_URL,
});

apiAuth.interceptors.request.use(async config => {
  const token = getTokenTMOV();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

apiAuth.interceptors.response.use(
  response => response,
  reject => {
    const originalRequest = reject.config;
    if (
      reject.response?.status === 401 &&
      !originalRequest._retry &&
      window.location.hash !== '#/'
    ) {
      return startRefreshToken(originalRequest);
    }
    return Promise.reject(reject);
  }
);

export default apiAuth;
